/**
 * A 2xx carrying HTML, which is never a valid answer from this API.
 *
 * It used to be a silent one. The server's SPA catch-all answered any unmatched
 * /api route with the React shell and a 200; the JSON parse returns null for a
 * non-JSON body, `res.ok` was true, and the request helper returned **null cast
 * to T**. The component got null where its type promised a response, nothing
 * threw and nothing was logged - a whole unmounted payment rail looked exactly
 * like an empty wallet.
 *
 * The server answers those with a JSON 404 now. This is the second lock.
 *
 * It lives in its own module because there are two apps: the client portal and
 * the admin portal, each with its own request helper, and the same rule written
 * twice is §13's Pattern H. The admin portal needs it at least as badly - the
 * catch-all serves an HTML 200 for any path it does not know, so a typo'd admin
 * endpoint would read as "no brands" rather than as a mistake.
 *
 * @module web/api/htmlGuard
 */

export function isHtml2xx(res: Response): boolean {
  return res.ok && (res.headers.get("content-type") ?? "").includes("text/html");
}
